<template>
  <div>
    <van-form>
      <van-cell-group inset v-if="preRoute.includes('order')">
        <van-cell @click="showStockSelect">
          <van-field
            autocomplete="off"
            v-model="form.scName"
            name="scName"
            inputmode="none"
            label="仓库"
            required
        /></van-cell>
        <van-cell @click="showSupplierSelect">
          <van-field
            autocomplete="off"
            required
            v-model="form.supplierName"
            name="supplierName"
            inputmode="none"
            label="供应商"
        /></van-cell>
        <!-- <van-cell>
          <van-field
           autocomplete="off"
            v-model="form.purchaserName"
            name="purchaserName"
            label="采购员"
        /></van-cell> -->
        <!-- <van-cell @click="openDateTimePicker">
          <van-field
            autocomplete="off"
            v-model="form.expectArriveDate"
            name="expectArriveDate"
            label="预计到货日期"
        /></van-cell> -->
      </van-cell-group>
      <van-cell-group inset v-if="preRoute.includes('return')">
        <van-cell @click="showPurchaseReceiveSelect">
          <van-field
            autocomplete="off"
            v-model="form.receiveSheetId"
            name="receiveSheetId"
            required
            inputmode="none"
            label="采购收货单"
        /></van-cell>
      </van-cell-group>
      <van-cell-group inset v-if="preRoute.includes('receive')">
        <van-cell @click="showPurchaseOrderSelect">
          <van-field
            autocomplete="off"
            v-model="form.purchaseOrderId"
            name="purchaseOrderId"
            inputmode="none"
            required
            label="采购订单"
        /></van-cell>
      </van-cell-group>
      <van-cell-group inset>
        <van-button
          @click="onSubmit"
          class="w-button"
          type="primary"
          :disabled="!isFormReady"
          >确定</van-button
        >
      </van-cell-group>
    </van-form>
    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDatePickerConfirm"
      @cancel="showDatePicker = false"
    ></DateTimePicker>
    <StockSelect
      :visible="stockSelectVisible"
      @confirm="stockSelectConfirm"
    ></StockSelect>
    <SupplierSelect
      :visible="supplierSelectVisible"
      @confirm="supplierSelectConfirm"
    ></SupplierSelect>
    <ReceiveSheetSelect
      :visible="receiveSheetSelectVisible"
      @confirm="receiveSheetSelectConfirm"
    ></ReceiveSheetSelect>
    <PurchaseOrderSelect
      :visible="purchaseOrderSelectVisible"
      @confirm="purchaseOrderSelectConfirm"
    ></PurchaseOrderSelect>
  </div>
</template>
<script>
import SupplierSelect from "../../../components/supplierSelect.vue";
import StockSelect from "../../../components/stockSelect.vue";
import DateTimePicker from "../../../components/dateTimePicker.vue";
import ReceiveSheetSelect from "../../../components/receiveSheetSelect.vue";
import PurchaseOrderSelect from "../../../components/purchaseOrderSelect.vue";

export default {
  name: "index",
  components: {
    StockSelect,
    SupplierSelect,
    DateTimePicker,
    ReceiveSheetSelect,
    PurchaseOrderSelect,
  },
  data() {
    return {
      form: {
        scId: null,
        supplierId: null,
        receiveSheetId: null,
        purchaseOrderId: null,
      },
      preRoute: "",
      showDatePicker: false,
      showDatePicker: false,
      stockSelectVisible: false,
      supplierSelectVisible: false,
      receiveSheetSelectVisible: false,
      purchaseOrderSelectVisible: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.fullPath && from.fullPath.includes("purchase")) {
        vm.previousRoute = from.fullPath;
        localStorage.setItem("previousRoute", from.fullPath);
      } else {
        vm.previousRoute = localStorage.getItem("previousRoute");
      }
    });
  },
  created() {},
  computed: {
    isFormReady() {
      if (this.preRoute.includes("return")) {
        return !!this.form.receiveSheetId;
      }
      if (this.preRoute.includes("order")) {
        console.log(!!this.form.scId, !!this.form.supplierId);
        return !!this.form.scId && !!this.form.supplierId;
      }
      if (this.preRoute.includes("receive")) {
        return !!this.form.purchaseOrderId;
      }
      return false;
    },
  },
  mounted() {
    this.preRoute = this.previousRoute ?? "";
    localStorage.setItem("purchaseReturning", "{}");
    localStorage.setItem("purchaseReceiveing", "{}");
    localStorage.setItem("purchaseOrdering", "{}");
  },
  methods: {
    showPurchaseOrderSelect() {
      this.purchaseOrderSelectVisible = true;
    },
    purchaseOrderSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.purchaseOrderSelectVisible = false;
        return;
      }
      this.purchaseOrderSelectVisible = false;
      this.form.purchaseOrderId = row.id;
      this.form.scName = row.scName;
      this.form.supplierName = row.supplierName;
    },
    showPurchaseReceiveSelect() {
      this.receiveSheetSelectVisible = true;
    },
    receiveSheetSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.receiveSheetSelectVisible = false;
        return;
      }
      this.receiveSheetSelectVisible = false;
      this.form.receiveSheetId = row.id;
      this.form.scName = row.scName;
      this.form.supplierName = row.supplierName;
    },
    showStockSelect() {
      this.stockSelectVisible = true;
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.form.scName = row.name;
      this.form.scId = row.id;
    },
    showSupplierSelect() {
      this.supplierSelectVisible = true;
    },
    supplierSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.supplierSelectVisible = false;
        return;
      }
      this.supplierSelectVisible = false;
      this.form.supplierName = row.name;
      this.form.supplierId = row.id;
    },
    openDateTimePicker() {
      this.showDatePicker = true;
    },
    onDatePickerConfirm(val) {
      if (!val) return;
      this.form[this.index] = val;
      this.showDatePicker = false;
    },
    validData() {
      if (this.preRoute.includes("return")) {
        if (this.$utils.isEmpty(this.form.receiveSheetId)) {
          this.$utils.createError("请选择采购收货单！");
          return false;
        }
      } else if (this.preRoute.includes("order")) {
        if (this.$utils.isEmpty(this.form.scId)) {
          this.$utils.createError("仓库不允许为空！");
          return false;
        }

        if (this.$utils.isEmpty(this.form.supplierId)) {
          this.$utils.createError("供应商不允许为空！");
          return false;
        }
      } else if (this.preRoute.includes("receive")) {
        if (this.$utils.isEmpty(this.form.purchaseOrderId)) {
          this.$utils.createError("请选择采购收货单！");
          return false;
        }
      }
      return true;
    },
    onSubmit() {
      if (!this.validData()) return;

      localStorage.setItem("queryForm", JSON.stringify(this.form));
      let path = "/product/category";
      let type = "purchaseOrder";
      if (this.preRoute.includes("order")) {
        path = "/product/category";
        type = "purchaseOrder";
      } else if (this.preRoute.includes("return")) {
        path = "/purchase/returnAdd";
        type = "purchaseReturn";
      } else if (this.preRoute.includes("receive")) {
        path = "/purchase/receiveAdd";
        type = "purchaseReceive";
      }
      this.$router.push({
        path: path,
        query: { type: type },
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
